
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/privacy",
      function () {
        return require("private-next-pages/es/privacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/privacy"])
      });
    }
  